<div class="orca-dialog">
    <div class="dialog-header">
        <h1 class="dialog-title">{{title}}</h1>

        <div class="dialog-btn-close">
            <button type="button" class="oa-icon-btn" (click)="matDialogRef.close()" aria-label="Fechar" matTooltip="Fechar">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>

    <div class="dialog-content">
        <h4>{{message}}</h4>
    </div>

    <!-- Botões do design system (opt-in via data.confirmVariant): Cancelar ghost + confirmação -->
    <div class="dialog-footer dialog-actions" *ngIf="confirmVariant; else legacyActions">
        <button type="button" *ngIf="showNo" class="oa-btn oa-btn--ghost" (click)="cancel()">
            {{noText}}
        </button>

        <button type="button" *ngIf="showYes" class="oa-btn" [ngClass]="'oa-btn--' + confirmVariant" (click)="confirm()"
            cdkFocusInitial>
            {{yesText}}
        </button>
    </div>

    <ng-template #legacyActions>
        <div class="dialog-footer dialog-actions">
            <button *ngIf="showYes" class="btn btn-red" (click)="confirm()" aria-label="Confirmar" matTooltip="Confirmar">
                {{yesText}}
            </button>

            <button *ngIf="showNo" class="btn btn-blue" (click)="cancel()" aria-label="Cancelar">
                {{noText}}
            </button>
        </div>
    </ng-template>
</div>